import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import {
  HomeIcon,
  CubeIcon,
  PlayIcon,
  CogIcon,
  Bars3Icon,
  XMarkIcon,
} from '@heroicons/react/24/outline';

const SolutionsSidebar = () => {
  const [expanded, setExpanded] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  const solutions = [
    { id: 1, name: 'Home', icon: HomeIcon, path: '/' },
    { id: 2, name: 'AutoDock', icon: CubeIcon, path: '/autodock' },
    { id: 3, name: 'Samplerun', icon: PlayIcon, path: '/samplerun' },
    { id: 4, name: 'AMRs', icon: CogIcon, path: '/amrs' },
  ];

  /* ---------------- DESKTOP + TABLET ---------------- */
  return (
    <>
      {/* Desktop / Tablet Sidebar */}
      <aside
        className="hidden md:flex fixed right-4 top-1/2 -translate-y-1/2 z-50"
        onMouseEnter={() => setExpanded(true)}
        onMouseLeave={() => setExpanded(false)}
        onClick={() => setExpanded((v) => !v)}
      >
        <div
          className={`transition-all duration-300 ease-in-out
            ${expanded ? 'w-60' : 'w-16'}
            bg-gradient-to-b from-[#141414] via-[#101010] to-[#0B0B0B]
            border border-[#1F1F1F]
            rounded-2xl shadow-[0_8px_30px_rgba(0,0,0,0.6)]
            px-2 py-3`}
        >
          <nav className="flex flex-col gap-1">
            {solutions.map(({ id, name, icon: Icon, path }) => (
              <NavLink
                key={id}
                to={path}
                className={({ isActive }) =>
                  `group relative flex items-center rounded-lg
                   transition-all duration-200
                   ${expanded ? 'px-3 py-2 gap-3' : 'p-3 justify-center'}
                   ${
                     isActive
                       ? 'bg-[#1C1C1C]'
                       : 'hover:bg-gradient-to-r hover:from-[#1A1A1A] hover:to-[#121212]'
                   }`
                }
              >
                {/* Accent */}
                {expanded && (
                  <span className="absolute left-0 top-1/2 -translate-y-1/2
                                   h-5 w-[2px] bg-[#FF3D5A] rounded-full
                                   opacity-0 group-hover:opacity-100" />
                )}

                <Icon className="w-5 h-5 text-[#9A9A9A] group-hover:text-[#FF3D5A]" />

                {expanded && (
                  <span className="text-sm font-medium text-[#E6E6E6]">
                    {name}
                  </span>
                )}
              </NavLink>
            ))}
          </nav>
        </div>
      </aside>

      {/* ---------------- MOBILE ---------------- */}
      <div className="md:hidden fixed bottom-4 right-4 z-50">
        {/* Toggle Button */}
        <button
          onClick={() => setMobileOpen((v) => !v)}
          className="p-3 rounded-full
                     bg-gradient-to-b from-[#1A1A1A] to-[#0E0E0E]
                     border border-[#2A2A2A]
                     shadow-lg"
        >
          {mobileOpen ? (
            <XMarkIcon className="w-6 h-6 text-[#FF3D5A]" />
          ) : (
            <Bars3Icon className="w-6 h-6 text-[#E6E6E6]" />
          )}
        </button>

        {/* Mobile Menu */}
        {mobileOpen && (
          <div
            className="absolute bottom-14 right-0 w-56
                       bg-gradient-to-b from-[#141414] to-[#0B0B0B]
                       border border-[#1F1F1F]
                       rounded-xl shadow-xl p-2"
          >
            {solutions.map(({ id, name, icon: Icon, path }) => (
              <NavLink
                key={id}
                to={path}
                onClick={() => setMobileOpen(false)}
                className="flex items-center gap-3 px-3 py-2 rounded-lg
                           hover:bg-[#1A1A1A]"
              >
                <Icon className="w-5 h-5 text-[#FF3D5A]" />
                <span className="text-sm font-medium text-[#EDEDED]">
                  {name}
                </span>
              </NavLink>
            ))}
          </div>
        )}
      </div>
    </>
  );
};

export default SolutionsSidebar;
